( function( $, window, document, undefined ) {
			$( document ).ready(function() {
				$('.js-slider-news').slick({
					slidesToShow: 3,
					slidesToScroll: 1,
					arrows: true,
					prevArrow: '<button class="slider__button slider__prev--large"><span class="u-visually-hidden">Previous</span></button>',
					nextArrow: '<button class="slider__button slider__next--large"><span class="u-visually-hidden">Next</span></button>',
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						}
					]
				});
				$('.js-slider-testimonials').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					mobileFirst: true,
					prevArrow: $( '.slider__buttons .slider__prev' ),
					nextArrow: $( '.slider__buttons .slider__next'),
					adaptiveHeight: true,
				});

				$('.js-slider-feature').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					dots: false,
					mobileFirst: true,
					adaptiveHeight: true,
				});

				$('.js-slider-vehicles').slick({
					slidesToShow: 4,
					slidesToScroll: 1,
					arrows: true,
					prevArrow: '<button class="slider__button slider__prev--large"><span class="u-visually-hidden">Previous</span></button>',
					nextArrow: '<button class="slider__button slider__next--large"><span class="u-visually-hidden">Next</span></button>',
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						}
					]
				});
				$('a.vehicle-main-gallery').featherlightGallery({
			    gallery: {
			        previous: '«',
			        next: '»',
			        fadeIn: 300
			    },
			    openSpeed: 300
			  });

				/* Launch single vehicle on button click. */
				( function( $, window, document, undefined ) {
					$( document ).ready(function() {
						$( '.js-gallery-vehicle-button' ).click(function( event ) {
							event.preventDefault();
							$('a.vehicle-main-gallery:first').click();
						});
					});
				})( jQuery, window, document );

				$('.js-slider-related-vehicles').slick({
					slidesToShow: 3,
					slidesToScroll: 1,
					arrows: true,
					prevArrow: '<button class="slider__button slider__prev--large"><span class="u-visually-hidden">Previous</span></button>',
					nextArrow: '<button class="slider__button slider__next--large"><span class="u-visually-hidden">Next</span></button>',
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						}
					]
				});
			});

		} )( jQuery, window, document );
